// extracted by mini-css-extract-plugin
export default {"table":"ImportTask_table__Hgb-r"};